<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="list"
      :product-options="productOptions"
      :selected-product="'cso'"
      :filter-names="filterNames"
      search-label="search"
      @filterOption="onFiltersChange"
    >
      <template v-slot:status="{ item }">
        <div>
          {{ item.status ? "Active" : "Inactive" }}
        </div>
      </template>
      <template v-slot:actions="{ item }">
        <v-icon
          v-if="isView"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-eye
        </v-icon>
        <v-icon
          v-if="isEdit"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          v-if="isDelete"
          class="mr-2"
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>

      <!-- add Filters -->
      <!-- <template #addFilters>
        <v-card v-if="authUser.isAdmin">

        </v-card>
      </template> -->
      <!-- add Filters -->
      <template #moreFilters>
        <div>
          <refresh-button
            :is-loading="isLoading"
            @reload="fetchData"
          />
        </div>
      </template>
      <!-- Action Modals -->
      <template #actionModals>
        <div>
          <create-cso-client
            v-if="isCreate"
            :filter-options="options"
          />

          <edit-cso-client
            v-if="(isEdit || isView) && editModal"
            :is-visible-dialog="editModal"
            :toggle-edit="toggleEditModal"
            :item="selectedRow"
          />
          <confirmation-modal
            v-if="isDelete"
            :is-visible="deleteModal"
            :toggle="toggleDeleteModal"
            :row="selectedRow"
          />
        </div>
      </template>
      <!-- Action Modals -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
// import { debounce } from "lodash";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    CreateCsoClient: () => import("./dialogs/CreateCSOClient.vue"),
    EditCsoClient: () => import("./dialogs/EditCSOClient.vue"),
    ConfirmationModal: () =>
      import("@/components/Modals/ConfirmationModal.vue"),
    refreshButton: () => import("@/components/base/RefreshButton.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      ocppIdModal: false,
      productOptions: [{ id: "cso", value: "CSO" }],
      permissions: {
        view: "user",
        create: "users.list",
        edit: "users.list",
        delete: "users.list",
      },
      filters: {},
      subFilters: {},
      interval: null,
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "csoClients/getLoading",
      meta: "csoClients/getMeta",
      list: "csoClients/getList",
      //
    }),
    _headers() {
      const headers = [
        {
          text: this.$t("name"),
          align: "left",
          sortable: false,
          value: "business_name",
        },
        {
          text: this.$t("tenant_name"),
          align: "left",
          sortable: false,
          value: "tenant_name",
          showAdmin: true,
        },
        {
          text: this.$t("email"),
          align: "left",
          sortable: false,
          value: "contact_email",
        },
        {
          text: this.$t("phone_number"),
          align: "left",
          sortable: false,
          value: "contact_no",
        },
        {
          text: this.$t("address"),
          align: "left",
          sortable: false,
          value: "address",
        },

        {
          text: this.$t("status"),
          align: "left",
          sortable: false,
          value: "status",
        },

        ...(this.isView || this.isEdit || this.isDelete
          ? [
              {
                text: this.$t("actions"),
                align: "left",
                sortable: false,
                value: "actions",
              },
            ]
          : []),
      ];

      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },

    filterNames() {
      return ["search", "status"];
    },
  },
  watch: {
    options() {
      this.fetchData();
    },
  },
  mounted() {
    // this.$store.dispatch("csmsChargeStations/setLoadingValue", true);
  },
  beforeDestroy() {
    const params = {
      name: "cso_clients",
      filters: this.options,
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {
    async fetchData() {
      const params = { ...this.options };
      params.status = params.status
        ? params.status == "active"
          ? "1"
          : "0"
        : null;

      await this.$store.dispatch("csoClients/list", params).then(() => {
        if (this.options.page > (this.meta?.lastPage || 1)) {
          this.options.page = 1;
        }
      });
    },

    // Confirmation of Delete Row
    async deleteSelectedRow(row) {
      try {
        await this.$store.dispatch("csoClients/destroy", row);
        this.$store.dispatch("alerts/success", this.$t("deleted_successfully"));
        if (this.list.length === 0 && this.meta.lastPage == this.options.page) {
          this.options.page -= 1; // Move to the previous page
        }
        this.toggleDeleteModal("close");
        this.fetchData();
      } catch (error) {
        this.$store.dispatch("alerts/error", error.response?.data?.message);
      }
    },
  },
};
</script>
<style scoped>
.row-box-wrap {
  display: flex;
  align-items: center;
  margin: 8px 0;
  gap: 10px;
  /* Adds space between items */
}

.text-muted {
  color: #6c757d;
}

.highlighted {
  font-weight: bold;
}

.copy-button {
  margin-left: auto;
  /* Pushes the button to the far right */
}
</style>
